module.exports = {"340209001":"中南街道","340209002":"马塘街道","340209003":"瀂港街道","340209004":"火龙街道","340209005":"白马街道","340209006":"南瑞街道","340209007":"三山街道","340209008":"保定街道","340209009":"龙湖街道","340209010":"高安街道","340209100":"峨桥镇","340209400":"芜湖高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340209.json
// module id = 1154
// module chunks = 0